"use client";

import React from "react";
const partners = [{
  tag: "BROWNFIELD AI CONVERSION",
  title: "Legacy-to-AI Data Center Conversion Partner",
  points: ["Acquisition of 100% net-leased, six-asset data center portfolio with $2.77M Year 1 NOI", "8.3-year WAULT with investment-grade tenancy across telecom and network operators", "Absolute NNN structure with full OpEx and CapEx borne by tenants", "3.2 MW (2N) critical capacity across six diversified U.S. markets", "Near-term renewal optionality with embedded escalation upside"]
}, {
  tag: "LATAM NEO CLOUD PLATFORM",
  title: "LATAM's First Certified GB300 Neo Cloud Partner",
  points: ["Developing the first certified GB300 Neo Cloud data center platform in LATAM by 2027", "Delivering high-density GPU/CPU capacity with superior ROI vs hyperscalers", "Modular design enabling rapid scaling aligned with AI workload demand", "Strengthens Mexico’s role in the U.S.–Canada digital corridor"]
}, {
  tag: "AI SERVER HARDWARE",
  title: "Tier-1 AI Server Manufacturer — Rack-Scale Integration",
  points: ["MOU to evaluate rack-scale integration for liquid-cooled AI deployments", "Aligns GPU supply, lifecycle management, and cluster commissioning", "Establishes Mexico Phase I blueprint for expansion across India & U.S."]
}, {
  tag: "CUSTOMER ACQUISITION & AI WORKLOAD ENABLEMENT",
  title: "Enterprise AI Onboarding & Go-to-Market Partner",
  points: ["Strategic customer acquisition engine for AI infrastructure assets", "Integrated marketing reducing cost of customer acquisition", "Improves utilization and revenue velocity across portfolio"]
}, {
  tag: "PRE-DEVELOPMENT & GPU INFRASTRUCTURE CAPITAL",
  title: "Institutional Co-Investment & GPU Capital Structuring Partner",
  points: ["Pre-development and GPU capital structuring for early-stage sites", "Hardware-backed financing strategy enabling capital efficiency", "Institutional co-investment expanding LP base and funding sources"]
}];
export default function StrategicPartnerships() {
  return <section id="strategic-partnerships" className="relative overflow-hidden bg-[#0b0b0d] text-white">
      {/* background grid */}
      <div className="absolute inset-0 opacity-[0.05] [background-image:linear-gradient(to_right,rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.04)_1px,transparent_1px)] [background-size:48px_48px]" />

      {/* blue radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(7,192,229,0.08),transparent_35%),radial-gradient(circle_at_bottom_right,rgba(7,192,229,0.05),transparent_35%)]" />

      <div className="relative mx-auto max-w-[1600px] px-6 py-24 md:px-10 xl:px-14">

        {/* Section label */}
        <div className="mb-12 flex items-center gap-4">
          <span className="h-px w-9 bg-[#07c0e5]" />
          <span className="font-mono text-[11px] uppercase tracking-[0.38em] text-[#07c0e5]">
            Strategic Partnerships
          </span>
        </div>

        {/* Title + intro */}
        <div className="mb-16 grid gap-12 lg:grid-cols-[1.05fr_0.95fr]">
          <div className="max-w-[760px]">
            <h2 className="font-serif text-[3.4rem] leading-[1.05] tracking-[-0.03em] sm:text-[4.4rem] md:text-[5.4rem]">
              An Ecosystem Built
              <br />
              for <span className="italic text-[#07c0e5]">Execution</span>
            </h2>
          </div>

          <div className="max-w-[700px] text-[1.1rem] leading-[1.85] text-[#9a9a9a]">
            N2N Capital has assembled a curated ecosystem of best-in-class
            strategic partners across every layer of the infrastructure stack —
            from brownfield conversion and AI hardware to enterprise customer
            acquisition and pre-development capital structuring.
          </div>
        </div>

        {/* Cards grid */}
        <div className="grid gap-6 lg:grid-cols-3">

          {partners.slice(0, 3).map(item => <div key={item.title} className="flex flex-col border border-[#0f3e47] bg-[rgba(12,12,14,0.6)] p-8 hover:border-[#07c0e5]/60 transition-colors">
              <div className="mb-6 font-mono text-[11px] uppercase tracking-[0.35em] text-[#07c0e5]">
                {item.tag}
              </div>

              <h3 className="mb-6 font-serif text-xl leading-snug text-white">
                {item.title}
              </h3>

              <ul className="space-y-3 text-[0.95rem] leading-relaxed text-[#9a9a9a]">
                {item.points.map((p, i) => <li key={i} className="flex gap-2">
                    <span className="mt-[7px] h-[4px] w-[4px] rounded-full bg-[#07c0e5]" />
                    <span>{p}</span>
                  </li>)}
              </ul>
            </div>)}

        </div>

        {/* bottom row */}
        <div className="mt-6 grid gap-6 lg:grid-cols-2">

          {partners.slice(3).map(item => <div key={item.title} className="flex flex-col border border-[#0f3e47] bg-[rgba(12,12,14,0.6)] p-8 hover:border-[#07c0e5]/60 transition-colors">
              <div className="mb-6 font-mono text-[11px] uppercase tracking-[0.35em] text-[#07c0e5]">
                {item.tag}
              </div>

              <h3 className="mb-6 font-serif text-xl text-white">
                {item.title}
              </h3>

              <ul className="space-y-3 text-[0.95rem] text-[#9a9a9a] leading-relaxed">
                {item.points.map((p, i) => <li key={i} className="flex gap-2">
                    <span className="mt-[7px] h-[4px] w-[4px] rounded-full bg-[#07c0e5]" />
                    <span>{p}</span>
                  </li>)}
              </ul>
            </div>)}

        </div>

        {/* disclaimer */}
        <p className="mt-16 text-xs text-[#6f6f6f] leading-relaxed">
          Disclaimer: The strategic partnerships described herein reflect
          non-binding memoranda of understanding (MOUs) that outline current
          intentions and areas of collaboration and do not constitute definitive
          commercial agreements, commitments to transact, or guarantees of
          future performance.
        </p>

      </div>
    </section>;
}